import React from 'react';
import Carousel, { CarouselProps } from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const MultiCarousel: React.FC<CarouselProps> = props => {
  return <Carousel {...props} />;
};

export default MultiCarousel;
